import axiosInstance from "../axiosInstance";

/**
 * Gửi phản hồi / báo lỗi / nhờ hỗ trợ (lưu CSDL nội bộ + đồng bộ Hameno Feedback Hub).
 * Có ảnh: gửi FormData (field `attachments`).
 */
export async function submitAppFeedback(payload, files = []) {
  const list = Array.isArray(files) ? files.filter(Boolean) : [];

  if (list.length > 0) {
    const fd = new FormData();
    if (payload.title) fd.append("title", payload.title);
    fd.append("message", payload.message || "");
    if (payload.category) fd.append("category", payload.category);
    if (payload.priority) fd.append("priority", payload.priority);
    if (payload.rating != null) fd.append("rating", String(payload.rating));
    if (payload.app_version) fd.append("app_version", payload.app_version);
    if (payload.device_info != null) {
      fd.append(
        "device_info",
        typeof payload.device_info === "string"
          ? payload.device_info
          : JSON.stringify(payload.device_info)
      );
    }
    list.forEach((file) => {
      fd.append("attachments", file);
    });

    const res = await axiosInstance.post("/system/feedback", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }

  const res = await axiosInstance.post("/system/feedback", payload);
  return res.data;
}

/**
 * Lấy danh sách nhật ký yêu cầu hỗ trợ (phân quyền: user thấy của mình, superadmin thấy tất cả).
 */
export async function getAppFeedbackList(params = {}) {
  const res = await axiosInstance.get("/system/feedback", { params });
  return res.data;
}

/**
 * Cập nhật trạng thái yêu cầu hỗ trợ (pending / in_progress / resolved).
 */
export async function updateAppFeedbackStatus(id, status) {
  const res = await axiosInstance.patch(`/system/feedback/${id}/status`, { status });
  return res.data;
}

/**
 * Xóa yêu cầu hỗ trợ.
 */
export async function deleteAppFeedback(id) {
  const res = await axiosInstance.delete(`/system/feedback/${id}`);
  return res.data;
}
